/**
 * Onde os recados aparecem: uma pilha no canto de baixo, à direita.
 *
 * Mora fora das telas, ao lado de `Dica` e `Paleta`, porque um recado
 * disparado por um formulário dentro de um cartão com `overflow: hidden`
 * seria cortado pela borda do cartão — e um aviso que aparece pela
 * metade é pior que nenhum.
 *
 * ⚠️ EMBAIXO, e não em cima: o cabeçalho da página é `sticky` e ocupa o
 * alto da tela em todas as telas do painel. Um recado ali disputaria o
 * lugar com o título e taparia o botão de ajuda.
 */

import { useEffect, useState } from 'react'
import { ouvirRecados, type Recado as TipoRecado } from '../recado'

/* Três na pilha e some em 6 s. O recado é curto e diz o que fazer AGORA;
   passado disso ele virou histórico, e histórico de validação não
   interessa a ninguém. */
const NA_PILHA = 3
const SOME_EM_MS = 6000

export function Recado() {
  const [pilha, setPilha] = useState<TipoRecado[]>([])

  useEffect(() => ouvirRecados(r => {
    setPilha(p => [r, ...p].slice(0, NA_PILHA))
    setTimeout(() => setPilha(p => p.filter(x => x.id !== r.id)), SOME_EM_MS)
  }), [])

  if (!pilha.length) return null

  return (
    <div className="recados" role="status" aria-live="polite">
      {pilha.map(r => (
        <div key={r.id} className={'recado ' + r.tipo}>
          <span className="recado-icone" aria-hidden="true">
            {r.tipo === 'erro' ? '!' : r.tipo === 'ok' ? '✓' : 'i'}
          </span>
          <span className="recado-texto">{r.texto}</span>
          {/* Dá para dispensar antes dos 6 s: quem já leu não precisa
              esperar o recado sair da frente sozinho. */}
          <button className="recado-x" aria-label="Dispensar"
                  onClick={() => setPilha(p => p.filter(x => x.id !== r.id))}>
            ✕
          </button>
        </div>
      ))}
    </div>
  )
}
